import { ScrollTop } from '@/components/element/ScrollTop';
import { SalesOrderContractTaskEditForm } from '@/components/features/tasks/sales_order_contract/[sales_order_contract_task_id]/SalesOrderContractTaskEditForm';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { useNavState } from '@/providers/NavStateProvider';
import { useCurrentSalesOrderContractTask } from '@/providers/SalesOrderContractTaskProvider';
import { useCurrentSalesOrder } from '@/providers/SalesOrderProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useEffect } from 'react';

export const BackofficeSalesOrderContractTaskEdit = () => {
  const { _w_, _t_ } = useCurrentTeamMember();
  const { _so_ } = useCurrentSalesOrder();
  const { setTitle, setBreadcrumbs } = useNavState();
  const { salesOrderContractTask: task } = useCurrentSalesOrderContractTask();
  useEffect(() => setTitle('契約申請（売上）タスク編集'), []);
  useEffect(
    () =>
      setBreadcrumbs([
        {
          label: `契約申請（売上）タスク一覧`,
          path: `/w/${_w_!.identifier}/backoffice/sales_order_contract_tasks`,
        },
        {
          label: `契約申請（売上）タスク詳細`,
          path: `/w/${_w_!.identifier}/backoffice/teams/${_t_!.id}/sales_orders/${
            _so_!.id
          }/sales_order_contract_tasks/${task!.id}`,
        },
      ]),
    []
  );

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <SalesOrderContractTaskEditForm />
    </WorkspaceLayout>
  );
};
